// en, de, fr, pt
export default {
	en: {
		HeavyEquipment:'Heavy Equipment and Special Labor',
		HeavyEquipment1:'We have source for the right equipment and heavy machine',
		HeavyEquipment2:'Suitable as you need',
		HeavyEquipment3:'With Reliability, Professional',
		HeavyEquipment4:'And Great price',
		Policy:'Policy',
		CeoHead:'25 years in Freight Forwarding and Logistics with specialist in Customs Formalities',
		CeoQuote:'MANAGEMENT Quote',
		CeoInfo:"'In the business world, espicially in logistics there are various challenges in completing each transaction, if you looking for Specialist, if you looking for Trust partner, --WE ARE--'",
		HeadOffice:'Head Office',
		BranchOffice:'Branch Office',
		HomeThirdText:'LOGISTIC HELPS YOU REALISE YOUR BUSINESS GOALS',
		HomeSecondText:'PROVIDING FIRST CLASS FREIGHT SERVICES',
		HomeForthText:'We are global supplier of transport and logistics solutions. We have an international network of partners and agents, making us a truly global player that offers services worldwide.',
		AboutWeareText:'We Are Logistic 1998 is experience and consultative Logistics company. We look ourselves as consultant for Customs regulations and concerned Government Laws. Over 20 years in Logistics field, our Customs specialist and experience staff can fulfill and meet customer expectation. We Are your business consultant We offer a wide range service coverage of Air freight, Sea freight, Multi-modal transportation ,Cross border service and Project cargo management.',
		HomePicText:'HomeChniesText',
		HomePicCover:'Home',
		AirFreight:'AirFreight',
		AirFreightText1:'Export / Import',
		AirFreightText2:'Direct daily airfreight to all major ports',
		AirFreightText3:'Daily consolidations to/from major worldwide ports',
		AirFreightText4:'Sea / Air products',
		AirFreightText5:'Express and Console services',
		AirFreightText6:'Domestic and international distribution',
		SeaFreight:'SeaFreight',
		SeaFreightText1:'Worldwide import and export services',
		SeaFreightText2:'Worldwide FCL services',
		SeaFreightText3:'Weekly consolidations / LCL',
		SeaFreightText4:'Multi-modal, door-to-door service available',
		ProjectHandling:'Project CargoHandling',
		DomesticandCrossborder:'Domestic & Crossborder',
		DomesticandCrossborderText1:'Inbound and Outbound',
		DomesticandCrossborderText2:'Multiple types of vehicles to support customers’ requirements',
		DomesticandCrossborderText3:'Door to Door service',
		DomesticandCrossborderText4:'In transit clearance license',
		DomesticandCrossborderText5:'GPS equipped with all trucks ',
		DomesticandCrossborderText6:'Connecting to Road network throughout all corridors around Thailand (Malaysia, Singapore, Myanmar, Laos and Cambodia)',
		DomesticandCrossborderText7:'Insurance coverage',
		PackingMoving:'Packing  Moving',
		CustomsClearance:'Customs Clearance',
		CustomsClearanceText1:'Customs Formalities',
		CustomsClearanceText2:'General import & export customs clearance formalities',
		CustomsClearanceText3:'Special formalities & Privileges(19Bis, BOI, Bonded, Free Zone, IEAT, ATA Carnet, FTA, Re-export, Re-import)',
		CustomsClearanceText4:'Value Added Service (Advance Tariff Ruling : ATR, Pre-checking import permit status, Duty refund)',
		CustomsClearanceText5:'Expert customs specialist',
		CustomsClearanceText6:'EDI Facilities',
		CustomsClearanceText7:'Customs regulation consultation (FTA & Privilege), related government regulation (TISI, FDA, DOA)',
		WarehouseManagement:'Warehouse Management',
		Management:'Management',
		VisionMission:'Vision & Mission',
		AboutWeare:'About WeAre',
		Portfolio:'Portfolio',
		ContactUs:'Contact Us',
		OurServices:'Our Services',
		AboutUs:'About Us',
		Home: 'Home',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
    ItemDetails: 'Item Details',
		Cart: 'Cart',
    WishList: 'Wish List',
		Checkout: 'Checkout',
		UI: 'UI',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
    CardColors: 'Card Colors',
		Table: 'Table',
    agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
    ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
    User: 'User',
    View: 'View',
    Edit: 'Edit',
    UserSettings: 'User Settings',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: "Export Selected",
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
	},
	th: {
		Policy:'นโยบาย',
		CeoHead:'ประสบการณ์ในการทำงานด้านโลจิสติกส์ มากกว่า 25 ปี โดยเฉพาะความชำนาญทางด้านพิธีการศุลกากร',
		CeoQuote:'สารจากผู้บริหาร',
		CeoInfo:"'ในโลกของธุรกิจ โดยเฉพาะอย่างยิ่งทางด้านโลจิสติกส์ที่มีการแข่งขันกันสูง หากคุณกำลังมองหาผู้ที่มีความรู้ความเชี่ยวชาญ หากคุณกำลังมองหาคู่ค้าที่ซื้อสัตย์ ไว้ใจได้ --เราคือคนนั้น--'",
		HeadOffice:'สำนักงานใหญ่',
		BranchOffice:'สำนักงานย่อย',
		HomeThirdText:'เราช่วยให้ธุรกิจคุณประสบความสำเร็จตามความคาดหมาย',
		HomeSecondText:'เราให้บริการคุณด้วยความเป็นเลิศด้านงานบริการ',
		HomeForthText:'เราเป็นผู้ให้บริการด้านลอจิสติกส์และด้านขนส่งด้วยความมาตรฐาน เรามีคู่ค้าและพันธมิตรอยู่ทั่วโลก ให้เราได้เป็นส่วนหนึ่งของผู้ให้บริการคุณ',
		AboutWeareText:'We Are Logistic 1998 เป็นผู้มีประสบการณ์และสามารถให้คำปรึกษาทางด้านโลจิสติก เราเป็นที่ปรึกษาด้านกฎระเบียบศุลกากรและที่เกี่ยวข้องกับทางภาครัฐ มานานกว่า 20 ปีในด้านโลจิสติกส์ เรามีผู้เชี่ยวชาญด้านศุลกากรและพนักงานที่มีประสบการณ์ เราสามารถเติมเต็มและตอบสนองความตอ้งการของลูกค้าได้ เรายังเป็นที่ปรึกษาทางธุรกิจของคุณ เราให้บริการครอบคลุมหลากหลายทั้งการขนส่งทางอากาศ การขนส่งทางทะเล การขนส่งหลายรูปแบบ บริการข้ามพรมแดนและการจัดการขนส่งสินค้า',
		HomePicText:'thaitest',
		HomePicCover:'หน้าหลัก',
		AirFreight:'ทางเครื่องบิน',
		AirFreightText1:'บริการส่งออก / บริการนำเข้า',
		AirFreightText2:'ให้บริการขนส่งตรงไปยังปลายทางหลัก',
		AirFreightText3:'ให้บริการขนส่งรวมสินค้าจากต้นทางไปยังปลายทางทั่วโลก',
		AirFreightText4:'ให้บริการขนส่งต่อเนื่องจากทางเรือไปยังทางแต่แบบต่อเนื่อง',
		AirFreightText5:'ให้บรการขนส่งสินค้าด่วน',
		AirFreightText6:'ให้บริการทั้งภายใน และ ภายนอกประเทศ',
		SeaFreight:'ทางเรือ',
		SeaFreightText1:'บริการนำเข้าและส่งออกทั่วโลก',
		SeaFreightText2:'บริการขนส่งแบบเต็มตู้',
		SeaFreightText3:'บริการขนส่งแบบรวมตู้',
		SeaFreightText4:'บริการขนส่งถึงสถานที่',
		ProjectHandling:'จัดการสินค้าเฉพาะทาง',
		DomesticandCrossborder:'สินค้าผ่านแดน',
		DomesticandCrossborderText1:'บริการนำเข้าและส่งออก',
		DomesticandCrossborderText2:'บริการขนส่งหลายหลายประเภทรถ ตามที่ลูกค้าต้องการ',
		DomesticandCrossborderText3:'บริการขนส่งถึงหน้าโรงงาน',
		DomesticandCrossborderText4:'ขนส่งข้ามแดนสะดวก ไม่ต้องเปลี่ยนถ่ายขนส่งตรงชายแดน',
		DomesticandCrossborderText5:'มีระบบติดตามสถานะสินค้าแบบอิเล็กทรอนิกส์และระบบจีพีเอส ',
		DomesticandCrossborderText6:'มีความชำนาญขนส่งข้ามแดนไปยังปลายทาง (มาเลเซีย,สิงค์โปร,พม่า,ลาว,กัมพูชา)',
		DomesticandCrossborderText7:'มีการรับประกันภัยให้สินค้า',
		PackingMoving:'บรรจุและเคลื่อนย้าย',
		CustomsClearance:'งานศุลกากร',
		CustomsClearanceText1:'บริการด้านพิธีการศุลกากร',
		CustomsClearanceText2:'บริการด้านพิธีการศุลกากร ในการนำเข้าและส่งออกทั่วไป',
		CustomsClearanceText3:'บริการด้านพิธีการศุลกากรแบบเฉพาะ(19ทวิ, BOI, สินค้าทัณฑ์บน, เขตปลอดอากร, IEAT, ATA Carnet, FTA, Re-export, Re-import)',
		CustomsClearanceText4:'บริการงานเฉพาะทาง (งานตรวจสอบพิกัด, งานตรวจสอบสถานะใบอนุญาติ, งานคืนภาษี)',
		CustomsClearanceText5:'บริการให้คำแนะนำนำเข้าส่งออกโดยผ่านพิธีการ',
		CustomsClearanceText6:'บริการส่งข้อมูลใบขนสินค้าผ่านพิธีการ',
		CustomsClearanceText7:'บริการเป็นที่ปรึกษาพิเศษ (FTA & Privilege), กฏหมายทางด้านศุลกากร (TISI, FDA, DOA)',
		WarehouseManagement:'บริหารคลังสินค้า',
		Management:'ผู้บริหาร',
		VisionMission:'วิสัยทัศน์ & พันธกิจ',
		AboutWeare:'เกี่ยวกับ WeAre',
		Portfolio:'ผลงานของเรา',
		ContactUs:'ติดต่อเรา',
		OurServices:'บริการของเรา',
		AboutUs:'เกี่ยวกับเรา',
		Home: 'หน้าหลัก',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
    ItemDetails: 'Item Details',
		Cart: 'Cart',
    WishList: 'Wish List',
		Checkout: 'Checkout',
		UI: 'UI',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
    CardColors: 'Card Colors',
		Table: 'Table',
    agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
    ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
    User: 'User',
    View: 'View',
    Edit: 'Edit',
    UserSettings: 'User Settings',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: "Export Selected",
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
	},
	cn: {
		Policy:'政策',
		CeoHead:'在貨運代理和物流領域擁有25年的專業海關經驗',
		CeoQuote:'管理報價',
		CeoInfo:"'在商業世界中，尤其是在物流方面，完成每筆交易都面臨著各種挑戰，如果您要尋找專家，如果您要尋找信託合作夥伴，-我們是-'",
		HeadOffice:'總公司',
		BranchOffice:'分支機構',
		HomeThirdText:'物流幫助您實現業務目標',
		HomeSecondText:'提供一流的貨運服務',
		HomeForthText:'我們是運輸和物流解決方案的全球供應商。我們擁有一個由合作夥伴和代理商組成的國際網絡，這使我們成為真正的全球參與者，可以在全球範圍內提供服務',
		AboutWeareText:'是經驗豐富的諮詢型物流公司。我們視自己為海關法規和有關政府法律的顧問。在物流領域有20多年的經驗，我們的海關專家和經驗豐富的人員可以滿足並滿足客戶的期望。我們是您的業務顧問。我們提供空運，海運，多式聯運，跨境服務和項目貨物管理的廣泛服務。',
		HomePicText:'HomeChniesText',
		HomePicCover:'家',
		AirFreight:'空運',
		AirFreightText1:'出口 / 進口',
		AirFreightText2:'每天直接空運到所有主要港口',
		AirFreightText3:'往返於全球主要港口的每日合併',
		AirFreightText4:'海 / 空氣 服務',
		AirFreightText5:'快速和控制台服務',
		AirFreightText6:'國內外發行',
		SeaFreight:'海洋貨運',
		SeaFreightText1:'全球進出口服務',
		SeaFreightText2:'全球全集裝箱服務',
		SeaFreightText3:'每週合併',
		SeaFreightText4:'提供多模式門到門服務',
		ProjectHandling:'項目貨物裝卸',
		DomesticandCrossborder:'國內跨境',
		DomesticandCrossborderText1:'入站和出站',
		DomesticandCrossborderText2:'多種類型的車輛可滿足客戶需求',
		DomesticandCrossborderText3:'門到門服務',
		DomesticandCrossborderText4:'過境通行證',
		DomesticandCrossborderText5:'GPS 配備所有卡車',
		DomesticandCrossborderText6:'連接到泰國各地（馬來西亞，新加坡，緬甸，老撾和柬埔寨）所有走廊的道路網絡',
		DomesticandCrossborderText7:'保險範圍',
		PackingMoving:'包裝移動',
		CustomsClearance:'報關',
		CustomsClearanceText1:'海關手續',
		CustomsClearanceText2:'一般進出口通關手續',
		CustomsClearanceText3:'特殊手續和特權(19Bis, BOI, 保稅區, 自由區, IEAT, ATA Carnet, FTA, Re-export, Re-import)',
		CustomsClearanceText4:'增值服務 (預先關稅, 預檢查進口許可證狀態, 退稅)',
		CustomsClearanceText5:'海關專家',
		CustomsClearanceText6:'EDI 設施',
		CustomsClearanceText7:'海關法規諮詢 (FTA & Privilege), 相關政府法規 (TISI, FDA, DOA)',
		WarehouseManagement:'倉庫管理',
		Management:'管理',
		VisionMission:'視力 & 任務',
		AboutWeare:'關於 WeAre',
		Portfolio:'作品集',
		ContactUs:'聯繫我們',
		OurServices:'我們的服務',
		AboutUs:'關於我們',
		Home:'家',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
    ItemDetails: 'Item Details',
		Cart: 'Cart',
    WishList: 'Wish List',
		Checkout: 'Checkout',
		UI: 'UI',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
    CardColors: 'Card Colors',
		Table: 'Table',
    agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
    ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
    User: 'User',
    View: 'View',
    Edit: 'Edit',
    UserSettings: 'User Settings',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: "Export Selected",
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
	},
	de: {
		Dashboard: 'Instrumententafel',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Machen',
		Chat: 'Plaudern',
		Email: 'Email',
		Calendar: 'Kalender',
    FullCalendar: 'Calendrier completVollständiger Kalender',
    SimpleCalendar: 'Einfacher Kalender',
		Shop: 'Geschäft',
    ItemDetails: 'Artikeldetails',
		Cart: 'Wagen',
    WishList: 'Wunschzettel',
		Checkout: 'Auschecken',
		UI: 'UI',
		DataList: 'Datenliste',
		ListView: 'Listenansicht',
		ThumbView: 'Daumenansicht',
		Grid: 'Gitter',
		Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Farben',
		Card: 'Karte',
		Basic: 'Basic',
		Statistics: 'Statistiken',
		Analytics: 'Analytics',
		CardActions: 'Kartenaktionen',
    CardColors: 'Kartenfarben',
		Table: 'Tabelle',
    agGridTable: 'agGrid-Tabelle',
		Components: 'Komponenten',
		Alert: 'Warnen',
		Avatar: 'Benutzerbild',
		Badge: 'Abzeichen',
		Breadcrumb: 'Breadcrumb',
		Button: 'Taste',
    ButtonGroup: 'Schaltflächengruppe',
		Chip: 'Chip',
		Collapse: 'Zusammenbruch',
		Dialogs: 'Dialoge',
		Divider: 'Teiler',
		DropDown: 'Dropdown-Liste',
		List: 'Liste',
		Loading: 'Wird geladen',
		Navbar: 'Navbar',
		Notifications: 'Benachrichtigungen',
		Pagination: 'Seitennummerierung',
		Popup: 'Pop-up',
		Progress: 'Fortschritt',
		Sidebar: 'Seitenleiste',
		Slider: 'Schieberegler',
		Tabs: 'Tabs',
		Tooltip: 'QuickInfo',
		Upload: 'Hochladen',
		FormsAndTable: 'Formulare und Tabelle',
		FormElements: 'Formularelemente',
		Select: 'Wählen',
		Switch: 'Schalter',
		Checkbox: 'Ankreuzfeld',
		Radio: 'Radio',
		Input: 'Eingang',
		NumberInput: 'Nummer eingeben',
		Textarea: 'Textbereich',
		FormLayouts: 'Formularlayouts',
		FormWizard: 'Formzauberer',
		FormValidation: 'Formularvalidierung',
    FormInputGroup: 'Formulareingabegruppe',
		Pages: 'Seiten',
		Authentication: 'Authentifizierung',
		Login: 'Anmeldung',
		Register: 'Registrieren',
		ForgotPassword: 'Passwort vergessen',
		ResetPassword: 'Passwort zurücksetzen',
		LockScreen: 'Bildschirm sperren',
    Miscellaneous: 'Verschiedenes',
		ComingSoon: 'Demnächst',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Nicht berechtigt',
		Maintenance: 'Instandhaltung',
		Profile: 'Profil',
    User: 'Benutzer',
    View: 'Aussicht',
    Edit: 'Bearbeiten',
    UserSettings: 'Benutzereinstellungen',
		Invoice: 'Rechnung',
		FAQ: 'FAQ',
		Search: 'Suche',
		KnowledgeBase: 'Wissensbasis',
		ChartsAndMaps: 'Diagramme und Karten',
		Charts: 'Diagramme',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Karte',
		Extensions: 'Erweiterungen',
		QuillEditor: 'Quill-Editor',
		DragAndDrop: 'Ziehen und loslassen',
		Datepicker: 'Datumsauswahl',
    DatetimePicker: 'Datum / Uhrzeit-Auswahl',
		AccessControl: 'Zugangskontrolle',
		I18n: 'I18n',
		Carousel: 'Karussell',
		Clipboard: 'Zwischenablage',
		ContextMenu: 'Kontextmenü',
    StarRatings: 'Sterne Bewertungen',
    Autocomplete: 'Autovervollständigung',
    Tree: 'Baum',
    // "Import/Export": 'Einführen/Export',
    Import: 'Einführen',
    Export: 'Export',
    ExportSelected: "Auswahl exportieren",
		Others: 'Andere',
		MenuLevels: 'Menüebenen',
		MenuLevel2p1: 'Menüebene 2.1',
		MenuLevel2p2: 'Menüebene 2.2',
		MenuLevel3p1: 'Menüebene 3.1',
		MenuLevel3p2: 'Menüebene 3.2',
		DisabledMenu: 'Deaktiviertes Menü',
		Support: 'Unterstützung',
		Documentation: 'Dokumentation',
		RaiseSupport: 'Unterstützung erheben',
		demoTitle: 'Kartentitel',
		demoText: 'Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.',
	},
	fr: {
		Dashboard: 'Tableau de bord',
		eCommerce: 'commerce électronique',
		Apps: 'Applications',
		Todo: 'Faire',
		Chat: 'Bavarder',
		Email: 'Email',
		Calendar: 'Calendrier',
    FullCalendar: 'Calendrier complet',
    SimpleCalendar: 'Calendrier simple',
		Shop: 'Boutique',
    ItemDetails: 'Détails de l\'article',
		Cart: 'Chariot',
    WishList: 'Liste de souhaits',
		Checkout: 'Check-out',
		UI: 'UI',
		DataList: 'Liste de données',
		ListView: 'Voir la liste',
		ThumbView: 'Thumb View',
		Grid: 'la grille',
		Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Couleurs',
		Card: 'Carte',
		Basic: 'De base',
		Statistics: 'Statistiques',
		Analytics: 'Analytique',
		CardActions: 'Actions de carte',
    CardColors: 'Couleurs de la carte',
		Table: 'Table',
    agGridTable: 'tableau agGrid',
		Components: 'Composants',
		Alert: 'Alerte',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Bouton',
    ButtonGroup: 'Groupe de boutons',
		Chip: 'Puce',
		Collapse: 'Effondrer',
		Dialogs: 'Dialogues',
		Divider: 'Diviseur',
		DropDown: 'Menu déroulant',
		List: 'liste',
		Loading: 'Chargement',
		Navbar: 'Barre de navigation',
		Notifications: 'Les notifications',
		Pagination: 'Pagination',
		Popup: 'Apparaitre',
		Progress: 'Le progrès',
		Sidebar: 'Barre latérale',
		Slider: 'Curseur',
		Tabs: 'Onglets',
		Tooltip: 'Info-bulle',
		Upload: 'Télécharger',
		FormsAndTable: 'Formulaires et tableau',
		FormElements: 'Éléments de formulaire',
		Select: 'Sélectionner',
		Switch: 'Commutateur',
		Checkbox: 'Case à cocher',
		Radio: 'Radio',
		Input: 'Contribution',
		NumberInput: 'Nombre d\'entrée',
		Textarea: 'Textarea',
		FormLayouts: 'Dispositions de formulaire',
		FormWizard: 'Assistant de formulaire',
		FormValidation: 'Validation du formulaire',
    FormInputGroup: 'Groupe de saisie de formulaire',
		Pages: 'Pages',
		Authentication: 'Authentification',
		Login: 'S\'identifier',
		Register: 'registre',
		ForgotPassword: 'Mot de passe oublié',
		ResetPassword: 'réinitialiser le mot de passe',
		LockScreen: 'Écran verrouillé',
    Miscellaneous: 'Divers',
		ComingSoon: 'Arrive bientôt',
		Error: 'Erreur',
		404: '404',
		500: '500',
		NotAuthorized: 'Pas autorisé',
		Maintenance: 'Entretien',
		Profile: 'Profil',
    User: 'Utilisateur',
    View: 'Vue',
    Edit: 'Modifier',
    UserSettings: 'Paramètres utilisateur',
		Invoice: 'Facture d\'achat',
		FAQ: 'FAQ',
		Search: 'Chercher',
		KnowledgeBase: 'Base de connaissances',
		ChartsAndMaps: 'Graphiques Et Cartes',
		Charts: 'Graphiques',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Carte',
		Extensions: 'Extensions',
		QuillEditor: 'Éditeur de piquants',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Sélecteur de date',
    DatetimePicker: 'Sélecteur de date / heure',
		AccessControl: `Contrôle d'accès`,
		I18n: 'I18n',
		Carousel: 'Carrousel',
		Clipboard: 'Presse-papiers',
		ContextMenu: 'Menu contextuel',
    StarRatings: 'Classement par étoiles',
    Autocomplete: 'Terminé automatiquement',
    Tree: 'Arbre',
    // "Import/Export": 'Importation/Exportation',
    Import: 'Importation',
    Export: 'Exportation',
    ExportSelected: "Exporter sélectionné",
		Others: 'Autre',
		MenuLevels: 'Niveaux de menu',
		MenuLevel2p1: 'Niveau de menu 2.1',
		MenuLevel2p2: 'Niveau de menu 2.2',
		MenuLevel3p1: 'Niveau de menu 3.1',
		MenuLevel3p2: 'Niveau de menu 3.2',
		DisabledMenu: 'Menu désactivé',
		Support: 'Soutien',
		Documentation: 'Documentation',
		RaiseSupport: 'Augmenter le soutien',
		demoTitle: 'Titre de la carte',
		demoText: `Le gâteau au sésame s'enclenche au petit pain au pain d'épices danois J'adore le pain d'épices. Tarte aux pommes et jujubes chupa chups muffin halvah sucette. Tiramisu gâteau au chocolat gâteau d'avoine tiramisu prune sucre. Donut tarte sucrée gâteau à l'avoine dragée gouttes de fruits gâteau au citron en barbe à papa.`,
	},
	pt: {
		Dashboard: 'painel de controle',
		eCommerce: 'comércio eletrônico',
		Apps: 'APPS',
		Todo: 'Façam',
		Chat: 'Bate-papo',
		Email: 'O email',
		Calendar: 'Calendário',
    FullCalendar: 'Calendário Completo',
    SimpleCalendar: 'Calendário Simples',
		Shop: 'fazer compras',
    ItemDetails: 'Detalhes do item',
		Cart: 'Carrinho',
    WishList: 'Lista de Desejos',
		Checkout: 'Confira',
		UI: 'UI',
		DataList: 'Lista de dados',
		ListView: 'Exibição de lista',
		ThumbView: 'Thumb View',
		Grid: 'Grade',
		Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Cores',
		Card: 'Cartão',
		Basic: 'Basic',
		Statistics: 'Estatisticas',
		Analytics: 'Analytics',
		CardActions: 'Ações do Cartão',
    CardColors: 'Cores do cartão',
		Table: 'Mesa',
    agGridTable: 'Tabela AgGrid',
		Components: 'Componentes',
		Alert: 'Alerta',
		Avatar: 'Avatar',
		Badge: 'Crachá',
		Breadcrumb: 'Breadcrumb',
		Button: 'Botão',
    ButtonGroup: 'Grupo de botões',
		Chip: 'Lasca',
		Collapse: 'Colapso',
		Dialogs: 'Diálogos',
		Divider: 'Divisor',
		DropDown: 'Suspenso',
		List: 'Lista',
		Loading: 'Carregando',
		Navbar: 'Navbar',
		Notifications: 'Notificações',
		Pagination: 'Paginação',
		Popup: 'Aparecer',
		Progress: 'Progresso',
		Sidebar: 'Barra Lateral',
		Slider: 'Controle Deslizante',
		Tabs: 'Guias',
		Tooltip: 'dica de ferramenta',
		Upload: 'Envio',
		FormsAndTable: 'Formulários e tabela',
		FormElements: 'Elementos do formulário',
		Select: 'Selecione',
		Switch: 'Interruptor',
		Checkbox: 'Caixa de seleção',
		Radio: 'Rádio',
		Input: 'Entrada',
		NumberInput: 'Entrada numérica',
		Textarea: 'Textarea',
		FormLayouts: 'Layouts de formulário',
		FormWizard: 'Assistente de Formulário',
		FormValidation: 'Validação de Formulário',
    FormInputGroup: 'Grupo de entrada de formulário',
		Pages: 'PÁGINAS',
		Authentication: 'Autenticação',
		Login: 'Entrar',
		Register: 'Registo',
		ForgotPassword: 'Esqueceu A Senha',
		ResetPassword: 'Redefinir Senha',
		LockScreen: 'Tela de bloqueio',
    Miscellaneous: 'Diversos',
		ComingSoon: 'Em breve',
		Error: 'Erro',
		404: '404',
		500: '500',
		NotAuthorized: 'Não autorizado',
		Maintenance: 'Manutenção',
		Profile: 'Perfil',
    User: 'Do utilizador',
    View: 'Visão',
    Edit: 'Editar',
    UserSettings: 'Configurações do Usuário',
		Invoice: 'Fatura',
		FAQ: 'Perguntas frequentes',
		Search: 'Procurar',
		KnowledgeBase: 'Base de Conhecimento',
		ChartsAndMaps: 'Gráficos E Mapas',
		Charts: 'Gráficos',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Mapa',
		Extensions: 'Extensão',
		QuillEditor: 'Quill-Editor',
		DragAndDrop: 'Arraste e solte',
		Datepicker: 'Datepicker',
    DatetimePicker: 'Seletor de data e hora',
		AccessControl: 'Controle de acesso',
		I18n: 'I18n',
		Carousel: 'Carrossel',
		Clipboard: 'Prancheta',
		ContextMenu: 'Menu contextual',
    StarRatings: 'Classificações por estrelas',
    Autocomplete: 'autocompletar',
    Tree: 'Árvore',
    // "Import/Export": 'Importar/Exportar',
    Import: 'Importar',
    Export: 'Exportar',
    ExportSelected: "Exportar Selecionado",
		Others: 'Outras',
		MenuLevels: 'Níveis de Menu',
		MenuLevel2p1: 'Nível de menu 2.1',
		MenuLevel2p2: 'Nível de menu 2.2',
		MenuLevel3p1: 'Nível de menu 3.1',
		MenuLevel3p2: 'Nível de menu 3.2',
		DisabledMenu: 'Menu desativado',
		Support: 'Apoio, suporte',
		Documentation: 'Documentação',
		RaiseSupport: 'Levantar Suporte',
		demoTitle: 'Título do cartão',
		demoText: `O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.`,
	}
}
